export default "/images/vendor/flag-icon-css/flags/4x3/gu.svg?459831ea94ce2f15eede065e961764df";